import React from "react";
import styles from "./StyledImage.module.scss";

interface StyledImageProps {
    imageURL: string;
    altText: string;
    aspectRatio: "1/1" | "4/3" | "16/9";
    maxWidth: string;
    borderColor?: string;
    rotation?: number;
    backgroundShadow?: "peel-shadow" | "drop-shadow";
    imageAboveFold?: boolean;
}

const StyledImage: React.FC<StyledImageProps> = ({
    imageURL,
    altText,
    aspectRatio = "4/3",
    maxWidth,
    borderColor = "#fff",
    rotation = 0,
    backgroundShadow,
    imageAboveFold = false,
}) => {
    return (
        <div
            className={getBackgroundShadowClass()}
            style={{ transform: `rotate(${rotation}deg)`, width: "100%" }}
        >
            <img
                className={styles.imageContent}
                style={{
                    aspectRatio: aspectRatio,
                    borderColor: borderColor,
                    maxWidth: maxWidth,
                }}
                src={imageURL}
                alt={altText}
                width="280px"
                height="280px"
            />
        </div>
    );

    function getBackgroundShadowClass() {
        if (!backgroundShadow) return;
        switch (backgroundShadow) {
            case "peel-shadow":
                return styles.peelShadow;
            case "drop-shadow":
                return styles.dropShadow;
        }
    }
};

export default StyledImage;
